<template>
    <div class="content-wrap content-wrap--bigger profile">
        <kapp-header id="mainHeader"></kapp-header>
        <form action="#">
            <figure class="profile-image" :class="{'is-uploading' : true}">
                <img :src="profileImage" alt="" />
                <label class="profile-uploadimage">
                    <i class="icon-bearbeiten"></i>
                    <input type="file"
                           enctype="multipart/form-data"
                           v-on:change="uploadImage"
                           class="sr-only">
                </label>
            </figure>

            <h1 class="profile-fullname" v-text="name + ' ' + surname"></h1>
            <p class="profile-info" v-html="info">Musterstelle</p>


            <p class="box">
                <label>
                    <span>Dunkelmodus<small>Verwende dunkle Farben</small></span>
                    <input type="checkbox"
                           v-model="darkMode"
                           value="1"
                           :checked="darkMode"
                           autocomplete="off"
                           class="sr-only"><span class="nice_checkbox"></span>
                </label>
            </p>
            <span class="profile-logout" @click="logout" v-if="isAuthenticated"><i class="icon-logout"></i><br />Logout</span>

            <!--<p class="box">-->
            <!--<label>-->
            <!--<span>Benachrichtigungen<small>Erhalte Neuigkeiten in Whatsapp</small></span>-->
            <!--<input type="checkbox"-->
            <!--v-model="notifications"-->
            <!--disabled-->
            <!--value="1"-->
            <!--:checked="notifications"-->
            <!--autocomplete="off"-->
            <!--class="sr-only"><span class="nice_checkbox"></span>-->
            <!--</label>-->
            <!--</p>-->

        </form>
    </div>
</template>

<script>
    import store from "@/utils/store";
    import { USER_UPDATE } from "@/utils/store/actions/user";
    import Header from "@/components/layouts/Header";
    import { mapGetters } from 'vuex';
    import {AUTH_LOGOUT} from "@/utils/store/actions/auth";

    export default {
        name: "KappProfile",
        components: {
            'kapp-header': Header
        },
        data() {
            return {
                profileImage: require('@/assets/images/bild_sw@2x.png'),
                surname: 'John',
                name: 'Doe',
                info: '',
                darkMode: this.$store.getters.getViewMode === 'dark',
                notifications: false
            };
        },
        computed: {
            ...mapGetters(['isAuthenticated', 'authStatus']),
        },
        beforeMount() {
            let storedProfile = store.getters.getProfile;
            this.profileImage = storedProfile.image;
            this.name = storedProfile.firstName;
            this.surname = storedProfile.lastName;

        },
        methods: {
            uploadImage: function ( evt ) {
                let file = evt.target.files[ 0 ];

                let formData = {
                    image: file
                };

                this.$store.dispatch(USER_UPDATE, formData)
                    .then(( response ) => {
                        if ( response ) this.profileImage = response.image;
                    })
                    .catch(( err ) => console.warn(err));
            },
            logout: function () {
                Events.$emit('logout', true);
                setTimeout(function () {
                    this.$store.dispatch(AUTH_LOGOUT).then(() => {
                        this.$router.push({name: 'Login'});
                    });
                }.bind(this), 300);
            }
        },
        watch: {
            darkMode: function ( newVal ) {

                let formData = {
                    darkMode: newVal
                };

                this.$store.commit('CHANGE_VIEWMODE');
            },
            notifications: function () {
            }
        }
    };
</script>

<style scoped>
    @import 'profile.css';
</style>



// WEBPACK FOOTER //
// src/pages/KappProfile/KappProfile.vue